import { Schedule, DAYS_OF_WEEK } from "@/types/schedule";
import { ScheduleCard } from "./ScheduleCard";

interface ScheduleListProps {
  schedules: Schedule[];
  onEdit: (schedule: Schedule) => void;
  onDelete: (id: string) => void;
}

export const ScheduleList = ({
  schedules,
  onEdit,
  onDelete,
}: ScheduleListProps) => {
  // Group schedules by day
  const groupedSchedules = DAYS_OF_WEEK.reduce((acc, day) => {
    const daySchedules = schedules.filter((s) => s.dayOfWeek === day.id);
    if (daySchedules.length > 0) {
      acc[day.id] = {
        label: day.label,
        schedules: daySchedules.sort((a, b) => a.startTime.localeCompare(b.startTime)),
      };
    }
    return acc;
  }, {} as Record<string, { label: string; schedules: Schedule[] }>);

  if (schedules.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        Nenhum horário cadastrado ainda
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {Object.entries(groupedSchedules).map(([dayId, { label, schedules }]) => (
        <div key={dayId} className="space-y-3">
          <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
            📅 {label}
          </h3>
          <div className="space-y-2">
            {schedules.map((schedule) => (
              <ScheduleCard
                key={schedule.id}
                schedule={schedule}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

